import { useAuthStore } from '@/stores/authStore.js'
import { useUserStore } from '@/stores/userStore.js'

export default function useStoreVersion() {
  const VERSION = 1

  function migrate() {
    const userStore = useUserStore()
    let oldVersion = userStore.currentStoreVersion
    let newVersion = VERSION
    let pendingMigrations = false

    // Generate a range from oldVersion + 1 to newVersion.
    // E.g. if oldVersion === 2 and newVersion === 6, then the array would be [3,4,5,6].
    // This means we'd be applying migrations from version 3 up to and including version 6.
    let migrationRange = Array.from({ length: newVersion - oldVersion}, (_, index) => index + oldVersion + 1)

    if (migrationRange.length > 0) pendingMigrations = true

    if (pendingMigrations) console.info(`Pinia Stores: Migrating from v${oldVersion} to v${newVersion}`)

    for (let migrationVersion of migrationRange) {
      console.info(`Pinia Stores: Migrating to v${migrationVersion}`)
      migrations[`migrateV${migrationVersion}`]()
      userStore.currentStoreVersion = migrationVersion
    }

    if (pendingMigrations) console.info(`Pinia Stores: Migration complete`)
  }

  const migrations = {
    migrateV1: () => {
      // The format for how Device Identifiers has changed.
      // Users MUST provision a new remote device at this point, even if they already have one.
      // Clearing the deviceIdentifier will force re-provisioning of a new Remote Device
      const authStore = useAuthStore()
      authStore.deviceIdentifier = undefined
    }
  }

  return {
    migrate
  }
}